export default __webpack_public_path__ + "static/media/elevate-bbl-banner-1.51eb67b0.jpg";